import { useApolloClient } from '@apollo/client';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useNavigate } from '@work4all/data';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { useHeaderInject } from '../../../../containers/file-entities-lists/components/contentWrapper/HeaderComponentProvider';

import {
  getErpSearch,
  getPositionSearch,
} from './use-erp-position-filter-mappings';

type ErpHeaderValues = 'receipts' | 'positions';

interface ErpPageHeaderProps {
  value: ErpHeaderValues;
  onChange: (value: ErpHeaderValues) => void;
  disablePosition?: boolean;
}

export const ErpPageHeader = (props: ErpPageHeaderProps) => {
  const { value, onChange, disablePosition } = props;
  const { t } = useTranslation();
  const handleChange = useCallback(
    (_e, value) => {
      onChange(value);
    },
    [onChange]
  );
  return (
    <div style={{ paddingRight: '1rem' }}>
      <Tabs
        value={value}
        onChange={handleChange}
        TabIndicatorProps={{ hidden: true }}
        variant="scrollable"
      >
        <Tab label={t('COMMON.TRAVELRECEIPTS')} value="receipts"></Tab>
        <Tab
          label={t('MASK.POSITIONS')}
          value="positions"
          disabled={disablePosition}
        ></Tab>
      </Tabs>
    </div>
  );
};

export const useErpHeader = (
  entity: Entities,
  currentValue: ErpHeaderValues,
  disablePosition?: boolean
) => {
  const navigate = useNavigate();
  const client = useApolloClient();

  const handleChange = useCallback(
    async (value: ErpHeaderValues) => {
      let variantUrl = '';

      // Map settings from one table to another
      if (value === 'positions') {
        const search = getPositionSearch();
        variantUrl = `positionDetails(${entity})${search ? `?${search}` : ''}`;
      } else {
        const search = await getErpSearch(client);
        variantUrl = `${entity}${search ? `?${search}` : ''}`;
      }

      navigate(`/more/entity/${variantUrl}`, {
        replace: true,
      });
    },
    [client, entity, navigate]
  );

  const headerElement = useMemo(
    () => (
      <ErpPageHeader
        value={currentValue}
        disablePosition={disablePosition}
        onChange={handleChange}
      />
    ),
    [currentValue, disablePosition, handleChange]
  );

  useHeaderInject(headerElement);
};
